/**
 * Controller: PriceListsCreateModal
 */
angular.module('acme.view.application.pricing.lists.createModal.controllers', [
  'acme.common.service.userPreferences'
])
.controller('PriceListsCreateModalController', [ '$scope', '$uibModalInstance', 'priceLists', function ($scope, $uibModalInstance, priceLists, currentPriceList) {

    $scope.errors = [];

    $scope.model = {
      name: '',
      description: '',
      effectiveStartTime: new Date(),
      effectiveEndTime: null,
      priceListType: null,
      prices: []
    };
    
    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=priceLists.length;i<ii;i++) {
        trimmed = $scope.trim(priceLists[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        }else{
          $scope.errors.push({ message: 'Please enter a valid name'});
        }
      }else{
        $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}])

.controller('PriceListsCreateModalDatePickerController', ['$scope', 'UserPreferencesService', '$timeout', function($scope, UserPreferencesService, $timeout) {

  $scope.priceListsCreateModalDatePicker = {

    isOpen: false,
    isPreferenceLoaded: false,

    dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
    
    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },
    

    init: function() {
      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $timeout(function () {
          $scope.priceListsCreateModalDatePicker.isPreferenceLoaded = true;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    getMinDate: function() {

      var d = new Date();

      d.setMonth(0);
      d.setDate(1);

      return d;

    },

    getMaxDate: function() {

      var d = new Date();

      d.setMonth(11);
      d.setDate(31);

      return d;

    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.minDate = this.getMinDate();
      $scope.maxDate = this.getMaxDate();

      this.isOpen = true;
    },
    
    onDateFormatLoad: function (e, data) {
      var self = $scope.priceListsCreateModalDatePicker;
      self.dateFormat = UserPreferencesService.getDateFormat('fieldDate', 'dateFormat');
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    }
    

  };
  
  $scope.priceListsCreateModalDatePicker.init();

}]);